import Slider from '@material-ui/core/Slider';
import makeStyles from '@material-ui/core/styles/makeStyles';
import withStyles from '@material-ui/core/styles/withStyles';

import { colors } from '../../assets';

export const useStyles = makeStyles({
  playButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  downloadButton: {
    position: 'absolute',
    right: 0,
  },
  playButton: {
    fontSize: '40px',
    padding: 0,
  },
  durationContainer: {
    marginTop: '21px',
  },
  timeContainer: {
    marginTop: '17px',
    display: 'flex',
    justifyContent: 'space-between',
    gap: 16,
  },
});

export const CustomSlider = withStyles({
  root: {
    padding: 0,
    color: colors.primary.main,
    height: 4,
  },
  thumb: {
    height: 10,
    width: 10,
    backgroundColor: '#fff',
    border: `2px solid ${colors.primary.main}`,
    marginTop: -3,

    '&.Mui-disabled': {
      border: `2px solid ${colors.grey60}`,
    },

    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  track: {
    height: 4,
    borderRadius: 5,
  },
  rail: {
    height: 4,
    borderRadius: 5,
    backgroundColor: colors.grey20,
  },
})(Slider);
